import { REWARD_BEHAVIOR_TYPE } from "../../../pages/dashboard/settings-coins/dropdown-values";

export const MESSAGE_VARIABLES = [
	{
		label: "$REWARD",
		value: 1,
	},
	{
		label: "$BALANCE",
		value: 2,
	},
];

export const formatDateToPHTParts = (utcDateStr) => {
	console.log({ utcDateStr });
	const utcDate = new Date(utcDateStr);

	// Define options for time only
	const timeOptions = {
		timeZone: "Asia/Manila",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	};

	// Manually extract date components in "YYYY-MM-DD" format
	const year = utcDate.toLocaleString("en-US", {
		timeZone: "Asia/Manila",
		year: "numeric",
	});
	const month = utcDate.toLocaleString("en-US", {
		timeZone: "Asia/Manila",
		month: "2-digit",
	});
	const day = utcDate.toLocaleString("en-US", {
		timeZone: "Asia/Manila",
		day: "2-digit",
	});

	// Combine for the final date and time strings
	const startDate = `${year}-${month}-${day}`; // YYYY-MM-DD
	const startTime = new Intl.DateTimeFormat("en-GB", timeOptions).format(
		utcDate
	); // HH:MM

	const endDate = `${year}-${month}-${day}`; // YYYY-MM-DD
	const endTime = new Intl.DateTimeFormat("en-GB", timeOptions).format(utcDate); // HH:MM
	return { startDate, startTime, endDate, endTime };
};

export const getBehaviorTypeLabel = (value) => {
	const behaviorTypeList = REWARD_BEHAVIOR_TYPE.filter((x) => x.value !== 2);

	const behavior = behaviorTypeList.find(
		(item) => item.value === parseInt(value)
	);
	return behavior ? behavior.name : "";
};
